import React from 'react';
import Navigation from '../tulote/Navigation';
import GeoJSONDocumentation from '../tulote/GeoJSONDocumentation';
import Footer from '../tulote/Footer';
import ThemeTogglerTwo from '../tulote/ThemeTogglerTwo';
import { ThemeProvider } from '../ThemeProvider';

function DocumentacionGeoJSONPage() {
  return (
    <ThemeProvider>
      <div className="min-h-screen bg-white dark:bg-gray-900 transition-colors">
        {/* Navigation */}
        <Navigation />

        {/* GeoJSON Documentation Section */}
        <section id="documentacion-geojson">
          <GeoJSONDocumentation />
        </section>

        {/* Footer */}
        <Footer />

        {/* Theme Toggle Button */}
        <div className="fixed bottom-6 right-6 z-50 hidden sm:block">
          <ThemeTogglerTwo />
        </div>
      </div>
    </ThemeProvider>
  );
}

export default DocumentacionGeoJSONPage;
